import { AbsenceType } from 'src/store/models/timetable/index.js'
import CRUD from 'src/store/models/helper/CRUD.js'
import Classbooks from 'src/api/classbooks.js'

export class Absence extends CRUD {
  static entity = 'absences'

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      begins_at: this.attr(null),
      ends_at: this.attr(null),
      begins_time_id: this.number(null),
      ends_time_id: this.number(null),
      comment: this.attr(''),
      absence_reason_id: this.number(-1),
      absence_reason: this.belongsTo(AbsenceType, 'absence_reason_id'),
      target_id: this.attr(-1),
      target_type: this.string(null),
      target: this.morphTo('target_id', 'target_type'),
      days: this.attr([]) // for substitutions
    }
  }

  static async saveAbsence (classbookId, uuid, absence, isUpdate) {
    return isUpdate ? Classbooks.putAbsencesById(classbookId, uuid, absence) : Classbooks.postAbsences(classbookId, absence)
  }
}

export default Absence
